import { HaNContext, HaNViewStoreContext } from "@lib/logic";
import { useRequiredContext } from "@lib/utils";

import { useConfirmDiscardingBooking } from "../details/useConfirmDiscardingBooking";

/**
 * Moves the page to another floor, which clears what's selected. Asks first when that would throw away a booking with
 * changes, and calls `onChanged` once the floor has changed.
 */
export const useChangeFloor = () => {
  const { floor } = useRequiredContext(HaNContext);
  const viewStore = useRequiredContext(HaNViewStoreContext);
  const confirmDiscardingBooking = useConfirmDiscardingBooking();

  return (floorId: string, onChanged?: () => void) => {
    confirmDiscardingBooking(() => {
      floor.selectFloor(floorId);
      viewStore.deselectAll();
      onChanged?.();
    });
  };
};
